export const INICIAR_SESION_CORRECTO_BACK = "INICIAR_SESION_CORRECTO_BACK"

export const CERRAR_SESION_BACK = "CERRAR_SESION_BACK"